WB.DataServices = WB.DataServices || {};

WB.DataServices.Snowski = function ($http, $q, _Config) {

    var _this = this;

    this.snowSkiUrl = _Config.BaseURLs.SnowSki.Prod;

    this.GetSnowskiDataByLatLng = function (lat, lng) {
        return $q(function(resolve, reject) {
            $http({
                method: 'GET',
                url: _this.snowSkiUrl + '/data/snowski/v1/ResortByLatitudeAndLongitude',
                params: {
                    latitude: lat,
                    longitude: lng,
                    rangeKm: 400,
                    maxResults: 6
                },
                hmac: true
            })
                .success(function(result) {
                    var x = result;
                    resolve(result);
                })
                .error(function(data) {
                    reject(new Error('Unable to get snowski info'));
                });
        });
    };
};
WB.DataServices.Snowski.$inject = ['$http', '$q', '_Config'];

WB.Core.service('SnowskiDataService', WB.DataServices.Snowski);
